import { Modal } from "@mui/material";

const MeetingTypeModal = ({
  isOpen,
  onClose,
  isOnlineMode,
  setIsOnlineMode,
  loading,
  error,
  startAttendance,
  t
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="meetingTypeModalContainer">
        <h3>{t.meetingTypeSelectorTitle}</h3>
        <p>{t.meetingTypeSelectorSubtitle}</p>

        <div className="meetingModeSelector">
          <button
            type="button"
            className={`meetingModeBtn ${!isOnlineMode ? "active" : ""}`}
            disabled={loading}
            onClick={() => setIsOnlineMode(false)}
          >
            {t.modePhysical}
          </button>
          <button
            type="button"
            className={`meetingModeBtn ${isOnlineMode ? "active" : ""}`}
            disabled={loading}
            onClick={() => setIsOnlineMode(true)}
          >
            {t.modeOnline}
          </button>
        </div>

        {error && <div className="meetingTypeError">{error}</div>}

        <div className="meetingTypeButtons">
          {t.meetingTypes.map((type) => (
            <button
              key={type}
              className="meetingTypeConfirmBtn"
              disabled={loading}
              onClick={() => startAttendance(type, isOnlineMode)}
            >
              {loading ? t.buttonLoading : type}
            </button>
          ))}
        </div>
        <button
          className="meetingTypeCancelBtn"
          onClick={onClose}
          disabled={loading}
        >
          {t.cancelBtn}
        </button>
      </div>
    </Modal>
  );
};

export default MeetingTypeModal;
